// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"a359fb6f","117":"14ed5c6b","137":"bb4d5835","497":"b710149e","608":"6d9d4301","636":"2649a205","679":"4183f625","726":"15e28141","778":"ad77523a","825":"6af89fed","854":"c4a4ee80","912":"6e8f1d78","934":"89da98ce"}[chunkId] + ".chunk.js";
};